import React from 'react';
import { AboutSection, StatsSection, ExperienceTimeline, ISOSection, TeamGallery } from '../components/Sections';
import { TestimonialsSection, FacebookFeed } from '../components/ExtraSections';
import { heroImages } from '../mock/data';

const About = () => (
  <div>
    <section className="relative h-[340px] flex items-center bg-black">
      <img src={heroImages.warehouse} alt="About" className="absolute inset-0 w-full h-full object-cover opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-transparent" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="flex items-center gap-3 mb-4"><span className="h-px w-10 bg-[#c8102e]" /><span className="eyebrow text-white">Our Story</span></div>
        <h1 className="text-white font-serif-display text-5xl md:text-6xl font-bold leading-[1.05]">Delivering happiness since 2014</h1>
      </div>
    </section>
    <AboutSection />
    <TeamGallery />
    <ExperienceTimeline />
    <StatsSection />
    <ISOSection />
    <FacebookFeed />
    <TestimonialsSection />
  </div>
);

export default About;
